// Investiture
import React from 'react';
import LiteraryAssociation9to122025 from '../views/LiteraryAssociation9to122025';


const InvestiturePage = () => {
  return <LiteraryAssociation9to122025 />;
};

export default InvestiturePage;
